import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@projectobelisk/uikit/components/feedback/empty";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { LayoutGrid } from "lucide-react";
import { useCurrentTenant } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/")({
  component: AppIndex,
});

function AppIndex() {
  const tenant = useCurrentTenant();

  if (tenant.modules?.includes("speed_to_lead")) {
    return <Navigate to="/speed-to-lead/campaigns" />;
  }

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <LayoutGrid />
        </EmptyMedia>
        <EmptyTitle>No modules enabled</EmptyTitle>
        <EmptyDescription>
          This workspace has no modules enabled yet. Contact your administrator
          to get started.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
